<template>
  <div id="app" class="d-flex flex-column h-100">
    <header>
      <b-navbar variant="light px-0 mx-0">
        <div class="container">
          <!-- <b-navbar-brand target="nav-collapse" exact to="/" class="d-block ml-0">Arkitekt Niels Vium
          </b-navbar-brand> -->
          <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
          <!-- <b-collapse id="nav-collapse" is-nav> -->
          <b-navbar-nav>
            <b-nav-item class="pr-0 pl-0" exact to="/">Arkitekt Niels Vium</b-nav-item>
            <b-nav-item class="d-none d-lg-flex pr-1" to="/bygninger">Bygninger</b-nav-item>
            <b-nav-item class="d-none d-lg-flex px-1" to="/projekter">Projekter</b-nav-item>
            <b-nav-item class="d-none d-lg-flex px-1" to="/restaureringer">Restaureringer</b-nav-item>
            <b-nav-item class="d-none d-lg-flex px-1" to="/kirker">Kirker</b-nav-item>
            <b-nav-item class="d-none d-lg-flex px-1" to="/malerier">Malerier</b-nav-item>
            <b-nav-item class="d-none d-lg-flex px-1" to="/tegninger">Tegninger</b-nav-item>
            <b-nav-item class="d-none d-lg-flex px-1" to="/cv">CV</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <!-- <b-navbar-nav class="ml-auto d-none d-lg-flex d-none d-lg-flex"> -->
          <!-- <b-nav-item to="/" exact class="small-caps">www.nielsvium.dk</b-nav-item> -->
          <!-- <b-nav-item target="_blank" class="small-caps px-0 mx-0" href="mailto:nielsvium@marselisvej.dk">
              nielsvium@marselisvej.dk</b-nav-item> -->
          <!-- <b-nav-item class="pr-0 px-0 mx-0">21630690</b-nav-item> -->
          <!-- </b-navbar-nav> -->
          <!-- </b-collapse> -->
        </div>
      </b-navbar>
    </header>

    <!-- Begin page content -->
    <main role="main" class="flex-shrink-0">
      <div class="container main-content">
        <router-view />
      </div>
    </main>

    <footer class="footer py-3">
      <div class="container">
        <span class="text-muted"></span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style scoped lang="scss">
@import "variables.scss";

a:focus {
  outline: none;
}

header {
  .navbar {
    a.nav-link {
      color: black;
      text-transform: uppercase;
    }

    .nav-link.active {
      border-bottom: 2px solid $line-color;
    }

    .navbar-brand.active {
      border-bottom: 2px solid $line-color;
    }

    a.nav-link,
    a.navbar-brand {
      border-bottom: 2px solid transparent;
      color: black;
      text-transform: uppercase;

      &:hover {
        border-bottom: 2px solid $line-color;
        color: black;
      }
    }

    a.nav-link.active,
    a.navbar-brand.active {
      color: $line-color;
    }
  }
}

#app header .bg-light {
  background-color: $bg-color !important;
}
</style>
